import React from "react";

export const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 800,
  autoplaySpeed: 4000,
};
